import {Component, Input} from '@angular/core';
import {TrackingService} from '@ox/data';
import {Plans} from '@ox/typings';
import {AppConfigService} from '@ox/utils';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'webu-disclosure-modal',
  templateUrl: './disclosure-modal.html'
})
export class DisclosureModalComponent {
  @Input()
  product: Plans[];
  brand: any;

  constructor(public bsModalRef: BsModalRef ,private appConfigService: AppConfigService, public trackingService: TrackingService) {
    this.brand = this.appConfigService.bml.brand;
  }
}
